module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h5', [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('pie-chart', {
    attrs: {
      "height": 155,
      "colorCycle": _vm.generateColorPool(_vm.totalDisplay(_vm.chartData), _vm.hueRange),
      "data": _vm.totalDisplay(_vm.chartData),
      "options": _vm.pieChartOptions
    },
    on: {
      "onClick": function($event) {
        return _vm.handleProfileClicked($event, _vm.chartData)
      }
    }
  }), _vm._v(" "), _c('chart-legend', {
    attrs: {
      "colorCycle": _vm.generateColorPool(_vm.totalDisplay(_vm.chartData), _vm.hueRange),
      "data": _vm.totalDisplay(_vm.chartData),
      "isPercentage": _vm.totalDisplayOption === 'percentage'
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d405f2e2","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"multiple":[{"search":"logo-white[.]svg","replace":"logo-white-live.svg","flags":"g"},{"search":"_variables","replace":"_variables_live","flags":"g"},{"search":"_theme","replace":"_live","flags":"g"}]}!./src/components/surveys/SpotProfileChart.vue
// module id = 3400
// module chunks = 3